<template>
    <transition name="fade">
        <div class="create-design-container">
            <div class="main-container">
                <div class="close-icon" @click="handleClose">
                            <Icon type="md-close"></Icon>
                        </div>
                <template v-if="current_state == 1">
                    <div class="main-title">余额充值</div>
                    <div class="charge-body">
                        <div class="charge-amount-title">
                            选择充值金额
                            <div class="gift-text" v-if="is_open_gift">
                                <span>充值立赠消费券</span>
                                <span>多充多送</span>
                                <span>购物更省钱</span>
                            </div>
                        </div>
                        <div class="charge-amount-list">
                            <div v-for="(item,index) in amount_list" :class="['charge-amount-item',{active:Number(amount) == Number(item.recharge_money)}]" :key="index" @click="onAmountSelected(item)">
                                 <div class="amount">¥{{ item.recharge_money }}</div>
                                 <div class="gift-amount" v-if="is_open_gift && item.gift_money > 0">
                                    加<span>送{{ item.gift_money }}</span>消费券
                                 </div>
                            </div>
                        </div>
                        <div class="custom-amount-title">自定义金额(元)</div>
                        <div class="custom-amount-input">
                            <div class="input-icon">¥</div>
                            <input type="number" min="0" placeholder="请输入金额" v-model="custom_amount" @input="onCustomAmountBlur" />
                        </div>
                        <div class="pay-methods-title">选择支付方式</div>
                        <div class="pay-methods-list">
                            <div v-for="(item,index) in pay_type_list" :key="index" :class="['pay-methods-item',{active:item.value===form.pay_type}]" @click="form.pay_type = item.value">
                                {{item.name}}
                                <img class="selected-icon" src="../assets/images/icon-selected-paymethods.png" />
                            </div>
                        </div>
                    </div>
                    <div class="charge-footer">
                        <div class="footer-container">
                            <div class="footer-amount">
                                <div class="sub-title">充值金额(元)</div>
                                <div class="final-amount">
                                    ¥{{ final_amount|price_format }}
                                    <div class="final-gift" v-if="is_open_gift && final_gift>0">
                                        / <div class="gift-money">
                                            <span>送{{ final_gift }}</span>消费券
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-btn-box">
                                <div class="cancel-btn" @click="handleClose">取消</div>
                                <div class="confirm-btn" @click="onChargePay">确认充值</div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="back-form">
                        <Icon type="ios-arrow-back" />
                        <span @click="handleBack">返回充值中心</span>
                    </div>
                    <div class="charge-info">
                        <p>订单提交成功,请您尽快付款!</p>
                        <p>充值账户: {{ userInfo.nickname || userInfo.account }}</p>
                        <p>充值金额: <span>¥{{final_amount|price_format}}</span>元</p>
                    </div>
                    <div class="charge-qrcode">
                        <img :src="form.pay_type | pay_methods_icon_logo" alt="" class="pay-methods-icon">
                        <div class="qrcode-body">
                            <div class="qrcode-wrap">
                                <img v-if="form.pay_type === 'wechat' && pay_info.pay_code" :src="pay_info.pay_code" alt="" class="qrcode-img">
                                <iframe v-else-if="form.pay_type === 'alipay' && pay_info.pay_code"
                                    ref="alipayIframe"
                                    width="252" 
                                    height="252" 
                                    frameborder="0"
                                    :srcdoc="pay_info.pay_code"
                                ></iframe>
                                <div v-else class="qrcode-img" style="display:flex;align-items:center;justify-content:center;">
                                    <Spin size="large"></Spin>
                                </div>
                            </div>
                            <div class="scan-tips-box">
                                <img src="../assets/images/icon-scan.png" alt="" class="scan-icon">
                                <div class="scan-tips">
                                    <p>请使用{{ form.pay_type | pay_methods_name }}扫一扫</p>
                                    <p>扫描二维码支付</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </transition>
</template>
<script>
let QRCode = require("qrcode");
import { CheckPayStatus, createRechargeOrder, getSetting, rechargePay } from '@/api/index';
import { mapState } from 'vuex';

export default{
    name:"BalanceCharge",
    data(){
        return{
            amount_list:[
                {recharge_money:500,gift_money:0},
                {recharge_money:1000,gift_money:0},
                {recharge_money:1500,gift_money:0},
                {recharge_money:2000,gift_money:0},
                {recharge_money:3000,gift_money:0},
                {recharge_money:5000,gift_money:0},
                {recharge_money:10000,gift_money:0},
                {recharge_money:20000,gift_money:0}
            ],
            pay_type_list:[
                {name:'微信支付',value:'wechat'},
                {name:'支付宝支付',value:'alipay'},
            ],
            form:{
                pay_type:'wechat'
            },
            current_state:1,
            pay_info:{},
            pay_check:null,
            amount:'',
            custom_amount:'',
            final_gift:0,
            is_open_gift:false,
            alipayFormContent:''
        }
    },
    props:{},
    computed:{
        final_amount(){
            return this.amount || this.custom_amount;
        },
        ...mapState({
            userInfo:state=>state.userInfo
        })
    },
    mounted(){
        console.log('charge-mounted');
        this.onGetSetting();
    },
    beforeDestroy(){
        if(this.pay_check){
            clearInterval(this.pay_check);
            this.pay_check = null;
        }
    },
    methods:{
        stopPayPolling(){
            if(this.pay_check){
                clearInterval(this.pay_check);
                this.pay_check = null;
            }
        },
        handleClose(){
            this.stopPayPolling();
            this.$emit('close-charge-pop');
        },
        handleBack(){
            this.stopPayPolling();
            this.current_state = 1;
        },
        async onGetSetting(){
            const {code,msg,data} = await getSetting({code:"finance",key:'recharge'});
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            console.log('data--->setting',data);
            if(data.recharge_list && data.recharge_list.length > 0){
                this.amount_list = data.recharge_list;
            }
            this.is_open_gift = data.open_gift;
        },
        onCustomAmountBlur(){
            this.amount = '';
        },
        onAmountSelected({recharge_money,gift_money}){
            this.amount = recharge_money;
            this.final_gift = gift_money;
            this.custom_amount = '';
        },
        onChargePay(){
            if(this.final_amount<=0){
                this.$layer.msg('充值金额必须大于0');
                return;
            }
            this.current_state = 2;
            this.getPayQrcode();
        },
        async getPayQrcode(){
            try{
                const {data} = await createRechargeOrder({...this.form,amount:this.final_amount});
                console.log('data',data);
                if(!data.id){
                    this.$layer.msg('创建订单失败');
                    return;
                }
                const {data:qrcode} = await rechargePay({id:data.id,'pay_type':this.form.pay_type})
                this.stopPayPolling();
                if(this.form.pay_type === 'wechat'){
                    let payQrcode;
                    QRCode.toDataURL(qrcode.url,{width:252,height:252}).then(url=>{
                        payQrcode = url;
                    }).finally(() => {
                        this.pay_info = {...data,pay_code:payQrcode};
                        this.pay_check = setInterval(() => {
                            CheckPayStatus({ pay_id: qrcode.pay_id }).then((res) => {
                                if (res.data.status === 1) {
                                    this.stopPayPolling();
                                    this.$emit('on-charge-success',{amount:this.final_amount})
                                }
                            });
                        }, 3000)
                    })
                } else if(this.form.pay_type === 'alipay'){
                    if(qrcode.type === 'form'){
                        this.pay_info = {...data,pay_code:qrcode.content};
                        setTimeout(() => {
                            const iframe = this.$refs.alipayIframe;
                            if (iframe && iframe.contentDocument) {
                                const form = iframe.contentDocument.querySelector("form");
                                if (form) {
                                    form.submit();
                                }
                            }
                        }, 500);
                    } else if(qrcode.url){
                        let payQrcode;
                        QRCode.toDataURL(qrcode.url,{width:252,height:252}).then(url=>{
                            payQrcode = url;
                        }).finally(() => {
                            this.pay_info = {...data,pay_code:payQrcode};
                        })
                    }
                    this.pay_check = setInterval(() => {
                        CheckPayStatus({ pay_id: qrcode.pay_id }).then((res) => {
                            if (res.data.status === 1) {
                                this.stopPayPolling();
                                this.$emit('on-charge-success',{amount:this.final_amount})
                            }
                        });
                    }, 3000)
                }
            }catch(e){
                console.log('err-get-pay-qrcode',e);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
 .create-design-container{
    width: 100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    position:fixed;
    top:0;
    left:0;
    z-index:101;
    display:flex;
    align-items:center;
    justify-content:center;
    .main-container{
        width:830px;
        // height:727px;
        border-radius:10px;
        background:#ffffff;
        position:relative;
        overflow:hidden;
        .close-icon{
            position:absolute;
            top: 20px;
            right: 25px;
            cursor:pointer;
        }
        .back-form{
            position:absolute;
            top:20px;
            left:25px;
            display:flex;
            align-items:center;
            cursor:pointer;
            span{
                color:#999999;
                font-size:14px;
            }
        }
        /**充值表单开始 */
        .main-title{
            width:100%;
            font-weight: bold;
            font-size: 24px;
            color: #000000;
            text-align: center;
            margin-top:31px;
            padding-bottom:25px;
            border-bottom:1px solid #ebebeb;
        }
        .charge-body{
            padding:32px 40px;
            display:flex;
            flex-direction:column;
            .charge-amount-title{
                display:flex;
                align-items:center;
                column-gap:10px;
                color:#1a1a1a;
                font-size:18px;
                font-weight:bold;
                .gift-text{
                    display:flex;
                    align-items:center;
                    column-gap:5px;
                    span{
                        font-size:12px;
                        color:#666;
                        &:first-child{
                            color:#fa3d5a;
                        }
                    }
                }
            }
            .charge-amount-list{
                display:flex;
                flex-wrap:wrap;
                gap:16px;
                margin-top:24px;
                .charge-amount-item{
                    width: 168px;
                    height:72px;
                    border-radius: 10px;
                    border:1px solid #e0e0e0;
                    cursor:pointer;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    flex-direction:column;
                    .amount{
                        color:#333;
                        font-size:20px;
                        font-weight:bold;
                    }
                    .gift-amount{
                        display:flex;
                        color:#666;
                        font-size:12px;
                        span{
                            color:#f9343e;
                        }
                    }
                    &.active, &:hover{
                        border:1px solid #fa3d5a;
                        .amount{
                            color:#fa3d5a;
                        }
                    }
                }
            }
            .custom-amount-title{
                color:#1a1a1a;
                font-size:14px;
                margin-top:40px;
                margin-bottom:16px;
            }
            .custom-amount-input{
                width:100%;
                height: 60px;
                border:1px solid #c0c4cc;
                border-radius:5px;
                display:flex;
                align-items:center;
                column-gap:10px;
                overflow:hidden;
                padding:0 20px;
                .input-icon{
                    color:#666666;
                    font-size:16px;
                }
                input{
                    border:none;
                    outline:none;
                    height:100%;
                    width:100%;
                }
            }
            .pay-methods-title{
                color:#1a1a1a;
                font-size:18px;
                font-weight:bold;
                margin-top:40px;
                margin-bottom:24px;
            }
            .pay-methods-list{
                display:flex;
                column-gap:20px;
                .pay-methods-item{
                    width:150px;
                    height:48px;
                    color:#333333;
                    font-size:16px;
                    text-align:center;
                    line-height:48px;
                    border:1px solid #cccccc;
                    cursor:pointer;
                    position:relative;
                    .selected-icon{
                        position:absolute;
                        top:0;
                        right:0;
                        width:30px;
                        height:24px;
                        display:none;
                    }
                    &.active, &:hover{
                        border:1px solid #3478ff;
                        .selected-icon{
                            display:block;
                        }
                    }
                }
            }
        }
        .charge-footer{
            width:100%;
            border-top:1px solid #ebebeb;
            .footer-container{
                padding:30px 40px;
                display:flex;
                align-items:center;
                justify-content:space-between;
                .footer-amount{
                    display:flex;
                    flex-direction:column;
                    .sub-title{
                        color:#1f1f1f;
                        font-size:14px;
                    }
                    .final-amount{
                        color:#fa3d5a;
                        font-size:28px;
                        font-weight:bold;
                        display:flex;
                        align-items:baseline;
                        column-gap:10px;
                        .final-gift{
                            display:flex;
                            align-items:baseline;
                            column-gap:10px;
                            font-size:14px;
                            color:#1f1f1f;
                            .gift-money{
                                display:flex;
                                align-items:baseline;
                                span{
                                    color:#f9343e;
                                }
                            }
                        }
                    }
                }
                .footer-btn-box{
                    display:flex;
                    column-gap:20px;
                    .cancel-btn{
                        width:130px;
                        height:48px;
                        border-radius:5px;
                        background:#ebebeb;
                        color:#333333;
                        font-size:14px;
                        text-align:center;
                        line-height:48px;
                        cursor:pointer;
                    }
                    .confirm-btn{
                        width:130px;
                        height:48px;
                        border-radius:5px;
                        background:#fa3d5a;
                        color:#ffffff;
                        font-size:14px;
                        text-align:center;
                        line-height:48px;
                        cursor:pointer;
                    }
                }
            }
        }
        /**充值表单结束 */

        /**扫码充值开始 */
        .charge-info{
            width:100%;
            display:flex;
            flex-direction:column;
            align-items:center;
            justify-content:center;
            row-gap:10px;
            margin-top:36px;
            border-bottom:1px solid #ebebeb;
            padding-bottom:20px;
            p{
                color:#666666;
                font-size:16px;
                span{
                    color:#fa3d5a;
                    font-size:28px;
                    font-weight:bold;
                }
            }
        }
        .charge-qrcode{
            width:100%;
            display:flex;
            flex-direction:column;
            align-items:center;
            justify-content:center;
            row-gap:10px;
            margin-top:30px;
            margin-bottom:100px;
            .pay-methods-icon{
                width:130px;
                height:46px;
                object-fit:cover;
                margin-bottom:30px;
            }
            .qrcode-body{
                border:1px solid #e3e3e3;
                display:flex;
                flex-direction:column;
                align-items:center;
                justify-content:center;
                .qrcode-wrap{
                    // padding:17px 17px 24px 17px;
                    .qrcode-img{
                        width:252px;
                        height:252px;
                    }
                }
                .scan-tips-box{
                    display:flex;
                    align-items:center;
                    column-gap:10px;
                    padding-bottom:30px;
                    .scan-icon{
                        width:34px;
                        height:32px;
                    }
                    .scan-tips{
                        color:#666666;
                        font-size:13px;
                    }
                }
            }
        }
        /**扫码充值结束 */
    }
 }
 
</style>